var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuilding4Fill = function SvgBuilding4Fill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.6 19.2h1.8V21H2.6v-1.8h1.8V3.9a.9.9 0 0 1 .9-.9h14.4a.9.9 0 0 1 .9.9zM8.9 11.1v1.8h2.7v-1.8zm0-3.6v1.8h2.7V7.5zm0 7.2v1.8h2.7v-1.8zm4.5 0v1.8h2.7v-1.8zm0-3.6v1.8h2.7v-1.8zm0-3.6v1.8h2.7V7.5z"
  })));
};
export default SvgBuilding4Fill;